module.exports = __webpack_public_path__ + "contents/menu/video/otukuri.mp4?a4a51a5144ae259a777d99a953cb1fbe";